__turbopack_context__.v({
  "actions": "DonationDetails-module-scss-module__Xabtja__actions",
  "caption": "DonationDetails-module-scss-module__Xabtja__caption",
  "captionopen": "DonationDetails-module-scss-module__Xabtja__captionopen",
  "impactEstimate": "DonationDetails-module-scss-module__Xabtja__impactEstimate",
  "impactExplanationContainer": "DonationDetails-module-scss-module__Xabtja__impactExplanationContainer",
  "wrapper": "DonationDetails-module-scss-module__Xabtja__wrapper",
});
